import type { TenantTheme } from '../types'

/**
 * Tema do tenant: Criminal Player
 * ID: 666c251f829bd6f1664320b7
 *
 * Cores baseadas no tema padrão atual da aplicação.
 * Para usar logo personalizado, adicione o arquivo em:
 *   public/tenants/666c251f829bd6f1664320b7/logo.svg
 * e altere logo.type para 'image'.
 */
const theme: TenantTheme = {
  id: 'criminal-player',
  appTitle: 'Ferramenta Transcrição',
  showHeaderLogo: false,
  palette: {
    primary: '#1976d2',
    primaryDark: '#1565c0',
    secondary: '#42a5f5',
  },
  logo: {
    type: 'image',
    iconGradient: ['#1976d2', '#1565c0'],
    src: '/tenants/criminal-player/logo.png',
    alt: 'Ferramenta Transcrição',
    width: { sm: 40, md: 64, lg: 175 },
    height: { sm: 40, md: 64, lg: 50 },
  },
  favicon: {
    type: 'image',
    value: '/tenants/criminal-player/favicon.jpg',
  },
}

export default theme
